'use client';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';
import { UserSponsor } from '@/types/players.types';
import { getSponsorImageByPriority } from '@/utils/helpers/getSponsorImageByPriority';

interface PrimarySponsorProps {
  sponsor: UserSponsor;
}

const PrimarySponsor = ({ sponsor }: PrimarySponsorProps) => {
  return (
    <div className='flex flex-col mb-8 sm:mb-16'>
      <div className='flex px-4 sm:px-8 py-3 items-center text-lg sm:text-xl text-white font-bold sm:font-semibold rounded-t-lg bg-[linear-gradient(90deg,#475467_0%,#667085_100%)] leading-4 sm:leading-0'>
        Primary Sponsors
      </div>
      <div className='flex h-[120px] max-h-[306px] p-6 items-center justify-center sm:h-[306px] bg-white rounded-b-lg border border-gray-300'>
        {sponsor.sponsorImages ? (
          sponsor.url ? (
            <a
              href={sponsor.url}
              target='_blank'
              className='size-full flex items-center'
              aria-label={`Link to ${sponsor.title} page (opens in a new tab)`}
              rel='noreferrer'
            >
              <ImageWithFallback
                alt={`${sponsor.title} Logo`}
                width={400}
                height={110}
                className='w-full h-24 sm:h-48 object-scale-down p-2'
                src={
                  getCDNURL(
                    getSponsorImageByPriority(sponsor.sponsorImages)?.url || '',
                    800,
                    800
                  ) || undefined
                }
              />
            </a>
          ) : (
            <ImageWithFallback
              alt={`${sponsor.title} Logo`}
              width={400}
              height={110}
              className='w-full h-24 sm:h-48 object-scale-down p-2'
              src={
                getCDNURL(getSponsorImageByPriority(sponsor.sponsorImages)?.url || '', 800, 800) ||
                undefined
              }
            />
          )
        ) : null}
      </div>
    </div>
  );
};

export default PrimarySponsor;
